import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from './pages/Main';
import Catalog from './pages/Catalog';
import ProductPage from './pages/ProductPage';
import ContractProduction from './pages/ContractProduction';
import SAWC from './pages/SAWC';
import NewsPage from './pages/NewsPage';
import Meteo from './pages/Meteo';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import { useState, useEffect } from 'react';
import { fetchInfo, fetchMainPage } from './strapi';
import Typography from '@mui/material/Typography';
import { fetchNavBar } from './strapi';
import CircularProgress from '@mui/material/CircularProgress';
import { CatalogContextProvider } from './CatalogContext.jsx';

// import { fetchFirstLevelSort, fetchSecondLevelSort } from './strapi';


function App() {
  const [newsId, setNewsId] = useState('');
  const [locale, setLocale] = useState('ru');
  const [current, setCurrent] = useState('/');
  let loading = locale == 'ru' ? 'Загрузка...' : 'Loading...';
  const names = [{ order: 0, name: 'main' }, { order: 1, name: 'main_' }, { order: 2, name: 'news' }, { order: 3, name: 'about' }, { order: 4, name: 'about_' }, { order: 5, name: 'products' }, { order: 6, name: 'documentation' }, { order: 7, name: 'contract production' }, { order: 8, name: 'career' }, { order: 9, name: 'contacts' }];
  const [main, setMain] = useState([]);
  const [info, setInfo] = useState({});
  const [navbar, setNavBar] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [showLoading, setShowLoading] = useState(true);
  const [showLoadingMessage, setShowLoadingMessage] = useState(false);
  const [sorting, setSorting] = useState('');
  const [sortingSecond, setSortingSecond] = useState('');
  function mainInit(data) {
    let arr = [];
    names.map((item, index) => {
      arr.push(data.find(o => o.name === item.name && index == item.order))
    })
    setMain(arr);
    //console.log(arr);
  }
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (window.location.hash) {
  //       const id = window.location.hash.substring(1);
  //       const el = id !== '' ? document.getElementById(id) : null;
  //       if (el) {
  //         const width = window.screen.width;
  //         const offset = width >= 700 ? 200 : 100
  //         const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
  //         window.scrollTo({ top: y, behavior: 'smooth' });
  //       }
  //     }
  //   }, 0);
  // }, [current])

  useEffect(() => {
    setLoadingData(true);
    Promise.all([
      fetchMainPage(locale).then(data => mainInit(data)),
      fetchInfo(locale).then(data => setInfo(data)),
      fetchNavBar(locale).then(data => setNavBar(data))
    ])
      .catch(err => { })
      .finally(() => setLoadingData(false));
  }, [locale]);

  useEffect(() => {
    let timeout;
    let messageTimeout;
    if (loadingData) {
      setShowLoading(true);
      setShowLoadingMessage(false);
      // Show message after 600ms if still loading
      messageTimeout = setTimeout(() => setShowLoadingMessage(true), 60);
    } else {
      setShowLoadingMessage(false);
      timeout = setTimeout(() => setShowLoading(false), 100);
    }
    return () => {
      clearTimeout(timeout);
      clearTimeout(messageTimeout);
    };
  }, [loadingData]);

  const isReallyLoading = showLoading || !main || main.length === 0 || main.every(item => !item);


  return (

      <div className="App">
        <div className="App" >
          {!isReallyLoading ? (
            <BrowserRouter>
              <NavBar navbar={navbar} locale={locale} setLocale={setLocale} current={current} setCurrent={setCurrent} />
              <div className='main_page'>
                {isReallyLoading ? (
                  <div style={{ color: '#2D5B96', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 100 }}>
                    <CircularProgress color='#2D5B96' />
                    <Typography sx={{ mt: 2 }}>{loading}</Typography>
                  </div>
                ) : (
                  <Routes>
                    <Route path="/" element={<Main setNewsId={setNewsId} current={current} setCurrent={setCurrent} locale={locale} main={main} info={info} />} />
                    <Route path={`/catalog/:sorting/:first`} element={<Catalog locale={locale} sorting={sorting} sortingSecond={sortingSecond} />} />
                    <Route path='/catalog' element={<Catalog locale={locale} />} />
                    {/* <Route path={"/catalog/"+ {sorting} + sorting ? '/' : '' + {sortingSecond}} element={<Catalog locale={locale} sorting={sorting} sortingSecond={sortingSecond}  />} /> */}
                    <Route path="/products/:id" element={<ProductPage locale={locale} />} />
                    <Route path="/contract-production" element={<ContractProduction locale={locale}/>} />
                    <Route path="/sawc" element={<SAWC locale={locale} />} />
                    <Route path="/news/:id" element={<NewsPage locale={locale} />} />
                    <Route path="/meteo" element={<Meteo locale={locale} />} />
                  </Routes>
                )}
              </div>
              {!isReallyLoading ? (<footer>
                <Footer info={info} locale={locale} navbar={navbar} />
              </footer>) : (<div></div>)
              }
            </BrowserRouter>
          ) : (
            <div></div>
          )}
        </div>
      </div>
  );
}

export default App;